import { createCoachApi } from '@sportik/api-coach/client';
import { auth } from '@/services/auth';

/**
 * The coach API client as this app configures it; only `services/` imports it.
 * Every request carries the auth provider's current token (ADR 0019).
 */
export const api = createCoachApi({
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  getAccessToken: auth.getAccessToken,
});
